<template>
  <div class="app-layout default-layout">
    <Header />
    <div class="app-content">
      <slot />
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./header";
import Footer from "../footer";

export default {
  name: "DefaultLayout",
  components: {
    Header,
    Footer
  },
  data() {
    return {};
  }
};
</script>